import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { TranslationService } from '../translations';
import { BasicPageLayoutOptions } from './BasicPageLayoutOptions';

@Component({
    selector: 'basic-page-body',
    template: `
        <div
            class="widthLimitedLayout--md"
            [ngClass]="{ 'widthLimitedLayout--enhanced': options.enhancedSize }"
        >
            <div
                [ngClass]="[
                    options.noWrap ? 'pageContentNoWrap' : 'pageContentWrap'
                ]"
            >
                @if (options.sideNav) {
                    <basic-page-side-navigation
                        style="margin-right: 50px"
                        [options]="options"
                    >
                        <ng-container page-side-nav>
                            <ng-content select="[page-side-nav]"></ng-content>
                        </ng-container>
                    </basic-page-side-navigation>
                }
                <div
                    class="pageContent--main"
                    [ngStyle]="{ 'flex-grow': options.noWrap ? '1' : '0' }"
                >
                    <div class="pageContentInterrupt">
                        <ng-content select="[page-main-title]"></ng-content>
                    </div>
                    <div
                        [ngClass]="[
                            options.bodyCssClass
                                ? options.bodyCssClass
                                : 'pageContent'
                        ]"
                    >
                        <div class="pageLayoutLoading">
                            <p>
                                {{ TR.key('label.common-terms.loading') }}
                                {{ options.pageDescription }}
                            </p>
                            <div class="spinner spinner--person"></div>
                        </div>
                        <ng-content select="[page-main-body]"></ng-content>
                    </div>
                </div>
                @if (
                    options.dlipContent ||
                    options.aside1Content ||
                    options.aside2Content ||
                    options.customAside
                ) {
                    <div class="pageContent--aside">
                        @if (options.aside1Content) {
                            <div class="asideContent">
                                <div class="pageContentInterrupt">
                                    <ng-content
                                        select="[page-aside1-title]"
                                    ></ng-content>
                                </div>
                                <div class="pageContent">
                                    <ng-content
                                        select="[page-aside1-body]"
                                    ></ng-content>
                                </div>
                            </div>
                        }
                        @if (options.dlipContent) {
                            <div class="dlipContent">
                                @if (options.dlipContent) {
                                    <div class="pageContentInterrupt">
                                        <div class="aside--dlipTitle">
                                            <div class="icon before color-dlip">
                                                <svg
                                                    viewBox="0 0 24 24"
                                                    class="icon-svg"
                                                >
                                                    <path
                                                        d="M23.391,1.568a1.959,1.959,0,0,0-1.438-.56c-3.841.114-7.707.868-9.656,2.308a.5.5,0,0,1-.594,0C9.754,1.876,5.888,1.122,2.047,1.008a1.951,1.951,0,0,0-1.438.56A2.021,2.021,0,0,0,0,3.009v14.5a2,2,0,0,0,1.956,2C7.923,19.678,11,21.327,11,21.993a1,1,0,0,0,2,0c0-.666,3.077-2.315,9.044-2.486a2,2,0,0,0,1.956-2V3.009A2.021,2.021,0,0,0,23.391,1.568ZM2.478,17.526a.5.5,0,0,1-.478-.5l-.012-13.5a.5.5,0,0,1,.523-.5C8.113,3.281,11,4.849,11,5.493V18.578a.5.5,0,0,1-.7.458A22.937,22.937,0,0,0,2.478,17.526Zm19.509-.5a.5.5,0,0,1-.479.5A22.909,22.909,0,0,0,13.7,19.036a.5.5,0,0,1-.7-.458V5.493c0-.643,2.886-2.211,8.477-2.464a.5.5,0,0,1,.523.5Z"
                                                    />
                                                </svg>
                                            </div>
                                            <span>Learn more with PI</span>
                                        </div>
                                    </div>
                                }
                                <div class="pageContent">
                                    <ng-content
                                        select="[page-dlip-body]"
                                    ></ng-content>
                                </div>
                            </div>
                        }
                        @if (options.aside2Content) {
                            <div class="asideContent">
                                <div class="pageContentInterrupt">
                                    <ng-content
                                        select="[page-aside2-title]"
                                    ></ng-content>
                                </div>
                                <div class="pageContent">
                                    <ng-content
                                        select="[page-aside2-body]"
                                    ></ng-content>
                                </div>
                            </div>
                        }
                        @if (options.customAside) {
                            <div class="asideContent">
                                <ng-content select="[customAside]"></ng-content>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    `,
    standalone: false
})
export class BasicPageBodyComponent {
    @Input()
    options: BasicPageLayoutOptions = {};
    @ViewChild('titleRef', { static: false })
    titleRef: ElementRef;
    @ViewChild('subtitleRef', { static: false })
    subtitleRef: ElementRef;

    constructor(public TR: TranslationService) {}
}
